<template>
  <div
    v-show="menuShow"
    class="contextmenu"
    :style="{ top: menuTop + 'px', left: menuLeft + 'px' }"
  >
    <ul @mouseup="handleMouseUp">
      <template v-if="curComponent">
        <template v-if="!curComponent.isLock">
          <li :disable="isBg" @click="addToAiChat">{{ $tt("加入AI对话") }}</li>
          <li :disable="isBg" @click="copy">{{ $tt("复制") }}</li>
          <li @click="paste">{{ $tt("粘贴") }}</li>
          <li :disable="isBg" @click="cut">{{ $tt("剪切") }}</li>
          <li :disable="isBg" @click="deleteComponent">{{ $tt("删除") }}</li>
          <li v-if="canDecompose" @click="decompose">{{ $tt("拆分") }}</li>
          <li :disable="isBg" @click="topComponent">{{ $tt("置顶") }}</li>
          <li :disable="isBg" @click="bottomComponent">{{ $tt("置底") }}</li>
          <li :disable="isBg" @click="upComponent">{{ $tt("上移一层") }}</li>
          <li :disable="isBg" @click="downComponent">{{ $tt("下移一层") }}</li>
        </template>
        <template v-else>
          <li @click="addToAiChat">{{ $tt("加入AI对话") }}</li>
          <li @click="unlock">{{ $tt("解锁") }}</li>
        </template>
      </template>
      <template v-else-if="isBatch">
          <li @click="addToAiChat">{{ $tt("加入AI对话") }}</li>
          <li v-if="canCompose" @click="compose">{{ $tt("组合") }}</li>
          <li @click="copy">{{ $tt("复制") }}</li>
          <li @click="paste">{{ $tt("粘贴") }}</li>
          <li @click="cut">{{ $tt("剪切") }}</li>
          <li @click="deleteComponent">{{ $tt("删除") }}</li>
      </template>
      <li v-else @click="paste">{{ $tt("粘贴") }}</li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";
import eventBus from '@/utils/eventBus'
import { ECOLOGICAL_SIGN } from '@/constants/editor';

export default {
  data() {
    return {
      copyData: null,
    };
  },
  computed: {
    ...mapState(["menuTop", "menuLeft", "menuShow", "curComponent", "areaData"]),
    isBg() {
      return this.curComponent && this.curComponent.id === 'Back';
      // return this.curComponent.id === 'Back' || this.curComponent.compType === ECOLOGICAL_CHILDREN_SIGN;
    },
    isBatch(){
      return this.areaData && this.areaData.components && this.areaData.components.length > 0
    },
    canCompose() {
      const comps = (this.areaData && this.areaData.components) || [];
      if (comps.length < 2) {
        return false;
      }
      return !comps.some((c) => c && c.component === "Group");
    },
    canDecompose() {
      return (
        this.curComponent &&
        !this.curComponent.isLock &&
        this.curComponent.component === "Group" &&
        this.curComponent.compType !== ECOLOGICAL_SIGN
      );
    },
  },
  methods: {
    lock() {
      this.$store.commit("lock");
    },

    unlock() {
      this.$store.commit("unlock");
      this.$store.commit("hideContextMenu");
    },

    // 点击菜单时不取消当前组件的选中状态
    handleMouseUp() {
      this.$store.commit("setClickComponentStatus", true);
    },

    addToAiChat() {
      if (this.isBg) {
        return;
      }
      const comps = this.isBatch
        ? ((this.areaData && this.areaData.components) || []).filter(
            (c) => c && c.id != null && String(c.id) !== "Back"
          )
        : this.curComponent && String(this.curComponent.id) !== "Back"
          ? [this.curComponent]
          : [];
      if (!comps.length) {
        this.$message.warning(this.$tt("请先选中要加入对话的组件"));
        this.$store.commit("hideContextMenu");
        return;
      }
      eventBus.$emit("canvasAiAddToChat", { components: comps });
      this.$store.commit("hideContextMenu");
    },

    cut() {
      if (this.isBg) {
        return;
      }
      this.$store.commit("cut", this.isBatch);
      this.$store.commit("hideContextMenu");
    },

    copy() {
      if (this.isBg) {
        return;
      }
      this.$store.commit("copy", this.isBatch);
      this.$store.commit("hideContextMenu");
    },

    paste() {
      // 背景上允许粘贴
      this.$store.commit("paste", true);
      this.$store.commit("recordSnapshot");
      this.$store.commit("hideContextMenu");
    },

    deleteComponent() {
      if (this.isBg) {
        return;
      }
      if(this.isBatch) {
        this.$store.commit("batchDeleteComponent", this.areaData.components || []);
        eventBus.$emit('hideArea')
      }else{
        this.$store.commit("deleteComponent");
      }
      this.$store.commit("recordSnapshot");
      this.$store.commit("hideContextMenu");
    },

    upComponent() {
      if (this.isBg) {
        return;
      }
      this.$store.commit("upComponent");
      this.$store.commit("recordSnapshot");
    },

    downComponent() {
      if (this.isBg) {
        return;
      }
      this.$store.commit("downComponent");
      this.$store.commit("recordSnapshot");
    },

    topComponent() {
      if (this.isBg) {
        return;
      }
      this.$store.commit("topComponent");
      this.$store.commit("recordSnapshot");
    },

    bottomComponent() {
      if (this.isBg) {
        return;
      }
      this.$store.commit("bottomComponent");
      this.$store.commit("recordSnapshot");
    },

    compose() {
      if (!this.canCompose) {
        return;
      }
      this.$store.commit("compose");
      this.$store.commit("recordSnapshot");
      this.$store.commit("hideContextMenu");
    },

    decompose() {
      if (!this.canDecompose) {
        return;
      }
      this.$store.commit("decompose");
      this.$store.commit("recordSnapshot");
      this.$store.commit("hideContextMenu");
    },
  },
};
</script>

<style lang="scss" scoped>
.contextmenu {
  position: fixed;
  z-index: 10000;

  ul {
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    margin: 5px 0;
    padding: 6px 0;

    li {
      font-size: 14px;
      padding: 0 20px;
      position: relative;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #606266;
      height: 34px;
      line-height: 34px;
      box-sizing: border-box;
      cursor: pointer;

      &:hover {
        background-color: #f5f7fa;
      }
      &[disable=true] {
        color: #dbdbdb;
        cursor: not-allowed;
      }
      &[disable=true]:hover {
        background-color: transparent;
      }
    }
  }
}
</style>